import React from 'react'
import { VStack, Separator } from '@chakra-ui/react'
import { CoinPlanRow } from './CoinPlanRow'

export const CoinPlanList = ({ coinPlans, onPlanSelect }) => (
  <VStack w="100%" py="8px" bg="white" borderY="1px" borderColor="divider.light" separator={<Separator w="100%" />} gap={0}>
    {coinPlans.map((plan) => (
      <CoinPlanRow key={plan.product_id} coin={plan.coin} iosPrice={plan.ios_price} webPrice={plan.web_price} onSelect={() => onPlanSelect(plan.product_id)} />
    ))}
  </VStack>
)
